import type { BaseElement } from 'slate';

import type { AlineText, SuggestedCheckboxEdit } from '../../internal';

export const checkboxType = 'checkbox' as const;
export type CheckboxType = typeof checkboxType;

export interface CheckboxElement extends BaseElement {
  children: AlineText[];
  suggestedEdits: SuggestedCheckboxEdit[];
  type: CheckboxType;
  /** Matches the enclosing option's `id` — an answer option's `choiceRefId`. */
  optionId?: string;
}

export type CheckboxProps = Omit<CheckboxElement, 'children'>;
